// Hot signals section (US-109) — section header with AI assist, a hint line,
// and the bullet-list sub-editor. JSX lifted verbatim from BusinessEditor.

import { useT } from '@barel/i18n';
import { BAiButton, Card } from '@barel/ui';

import { BulletListEditor } from '../PainEditor';
import type { BusinessDraft } from '../lib/defaults';
import { SectionHeader } from './SectionHeader';
import type { RunAi, SetField } from './types';

export interface HotSignalsSectionProps {
  hotSignals: BusinessDraft['hotSignals'];
  onChange: SetField;
  runAi: RunAi;
  aiBusyField: string | null;
}

export function HotSignalsSection({
  hotSignals,
  onChange,
  runAi,
  aiBusyField,
}: HotSignalsSectionProps) {
  const t = useT('businesses');

  return (
    <Card padding="lg" radius="2xl" data-testid="business-section-hotsignals">
      <SectionHeader
        title={t('sections.hotSignals')}
        subtitle={t('hotSignals.subtitle')}
        action={
          <BAiButton
            onClick={() => void runAi('hotSignals')}
            busy={aiBusyField === 'hotSignals'}
            label={t('hotSignals.ai')}
            busyLabel={t('hotSignals.aiBusy')}
            data-testid="business-hotsignals-ai"
          />
        }
      />
      <p className="mb-2 text-xs italic text-tertiary">{t('hotSignals.hint')}</p>
      <BulletListEditor
        values={hotSignals}
        onChange={(next) => onChange('hotSignals', next)}
        placeholder={t('hotSignals.placeholder')}
        addLabel={t('hotSignals.add')}
        tone="warning"
        testId="business-hotsignals"
      />
    </Card>
  );
}
